import React from "react";
import ShotControls from "./ShotControls";
import ShotVisuals from "./ShotVisuals";
import { useTheme } from "../../../context/ThemeContext";
import { Plus, Check } from "lucide-react";

const ShotCardList = React.memo((props) => {
  const { 
    index, 
    handleInsertRow,
    selectedShots,
    toggleShotSelection,
    isMultiSelectMode,
  } = props;
  const { getTheme } = useTheme();
  const theme = getTheme();

  const isSelected = selectedShots?.has(index);

  return (
    <div
      className="group relative production-panel p-4 transition-colors duration-200 flex flex-col md:flex-row gap-4 items-stretch"
      style={{
        backgroundColor: isSelected ? `${theme.colors.accentPrimary}08` : 'var(--color-bg-card)',
        borderColor: isSelected ? theme.colors.accentPrimary : 'var(--color-border-secondary)',
        boxShadow: 'none',
      }}
      onMouseEnter={(e) => { if (!isSelected) { e.currentTarget.style.borderColor = 'var(--color-border-hover)'; }}}
      onMouseLeave={(e) => { if (!isSelected) { e.currentTarget.style.borderColor = 'var(--color-border-secondary)'; }}}
    >
      {/* 多选复选框 */}
      {isMultiSelectMode && (
        <div 
          className="absolute -top-3 -left-3 z-20"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={() => toggleShotSelection(index)}
            className="w-7 h-7 rounded-md flex items-center justify-center transition-all duration-200"
            style={{
              backgroundColor: isSelected ? theme.colors.accentPrimary : 'var(--color-bg-secondary)',
              border: `2px solid ${isSelected ? theme.colors.accentPrimary : 'var(--color-border-primary)'}`,
              color: isSelected ? 'white' : 'transparent',
            }}
            onMouseEnter={(e) => { if (!isSelected) { e.currentTarget.style.borderColor = theme.colors.accentPrimary; e.currentTarget.style.backgroundColor = `${theme.colors.accentPrimary}20`; }}}
            onMouseLeave={(e) => { if (!isSelected) { e.currentTarget.style.borderColor = 'var(--color-border-primary)'; e.currentTarget.style.backgroundColor = 'var(--color-bg-secondary)'; }}}
            aria-label={isSelected ? "取消选择镜头" : "选择镜头"}
            title={isSelected ? "取消选择镜头" : "选择镜头"}
          >
            {isSelected && <Check size={14} strokeWidth={3} />}
          </button>
        </div>
      )}

      {/* ShotControls */}
      <ShotControls {...props} />

      {/* ShotVisuals */}
      <ShotVisuals {...props} />

      {/* 插入按钮 */}
      {!isMultiSelectMode && (
        <div
          onClick={() => handleInsertRow(index + 1)}
          className="absolute -bottom-3 left-0 w-full h-6 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer z-10"
          title="插入新镜头"
        >
          <div className="h-px w-full" style={{ background: `linear-gradient(90deg, transparent, ${theme.colors.accentPrimary}66, transparent)` }}></div>
          <div
            className="absolute rounded-md p-1 transition-colors"
            style={{ backgroundColor: 'var(--color-bg-primary)', border: `1px solid ${theme.colors.accentPrimary}`, color: theme.colors.accentPrimary }}
          >
            <Plus size={12} strokeWidth={3} />
          </div>
        </div>
      )}
    </div>
  );
});

export default ShotCardList;
